module.exports = __webpack_public_path__ + "static/img/securitybg1.e6fd3c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/securitybg1.jpg
// module id = O5U0
// module chunks = 1